import createAxiosInstance from './axiosConfig';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/processadoraCartaoController');

export default class ProcessadoraCartaoService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async consultarLimiteConta(body: any) {
    return await this.axios.post(`/consultarLimiteConta`, body);
  }

  async segundaViaCartao(body: any) {
    return await this.axios.post(`/segundaViaCartao`, body);
  }

  async cancelaConta(body: any) {
    return await this.axios.post(`/cancelaConta`, body);
  }

  async rastreioCartao(body: any) {
    return await this.axios.post(`/rastreioCartao`, body);
  }

}
